/* eslint-env browser */
import PropTypes from 'prop-types'
import * as React from 'react'

import withTranslator from '../TranslatorProvider'
const { captureException } = require('../../services/sentry-service')

const moment = require('moment')
const axios = require('axios')
const classNames = require('classnames')

const StarsDisplay = require('../Notes/StarsDisplay')
const EmptyImagesGenerator = require('../../../../../../shared/services/empty-images-generator')
const EmptyData = require('../EmptyData')

class OpinionsList extends React.PureComponent {
  constructor() {
    super()
    this.postOpinion = this.postOpinion.bind(this)
    this.onLoadMore = this.onLoadMore.bind(this)
    this.updateOpinions = this.updateOpinions.bind(this)
    this.state = {
      titleInput: '',
      commentInput: '',
      opinions: [],
      totalOpinionsCount: 0,
      editingCurrentOpinion: false,
    }
  }

  componentWillMount() {
    const { opinions, totalOpinionsCount, mostRecentOnTop, currentUserOpinion } = this.props

    if (opinions) {
      this.setState({
        currentUserOpinion,
        opinions: opinions.sort((a, b) =>
          mostRecentOnTop
            ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            : new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        ),
      })
    }
    if (typeof totalOpinionsCount !== 'undefined') {
      this.setState({ totalOpinionsCount })
    }
  }

  componentWillReceiveProps(nextProps) {
    const { opinionable: nextOpinionable, opinionableId: nextOpinionableId, mostRecentOnTop, opinions } = nextProps
    const { opinionable, opinionableId } = this.props
    if (nextOpinionable !== opinionable || nextOpinionableId !== opinionableId) {
      this.setState({
        opinions: opinions.sort((a, b) =>
          mostRecentOnTop
            ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            : new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        ),
      })
    }
  }

  onLoadMore() {
    const { opinionable, opinionableId, mostRecentOnTop } = this.props
    const { opinions } = this.state

    let firstComment = opinions[0]
    if (mostRecentOnTop) {
      firstComment = opinions[opinions.length - 1]
    }
    this.setState({ loadingMore: true })
    return axios
      .get(`/api/opinions/${opinionable}/${opinionableId}`, {
        params: {
          before: firstComment ? new Date(firstComment.createdAt).getTime() : undefined,
          limit: 10,
        },
      })
      .then(res => {
        this.setState({ totalOpinionsCount: parseFloat(res.headers['x-total-count']) })
        this.updateOpinions(res.data)
      })
      .catch(err => {
        captureException(err)
        this.setState({ loadingMore: false })
      })
  }

  setNote(e, note) {
    e.preventDefault()
    const { isNoteSet } = this.state
    if (!isNoteSet) {
      this.setState({ currentNote: note })
    }
    return false
  }

  setNoteClick(e, note) {
    e.preventDefault()
    this.setState({
      currentNote: note,
      isNoteSet: true,
    })
    return false
  }

  updateOpinions(newOpinions) {
    const { mostRecentOnTop } = this.props
    const { opinions } = this.state

    const existingOpinionsIds = opinions.map(elt => elt.id)
    const newOpinionsFiltered = newOpinions.filter(elt => existingOpinionsIds.indexOf(elt.id) === -1)
    this.setState({
      opinions: opinions
        .concat(newOpinionsFiltered)
        .sort((a, b) =>
          mostRecentOnTop
            ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            : new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        ),
      loadingMore: false,
    })
  }

  postOpinion(e) {
    e.preventDefault()

    const { opinionable, opinionableId } = this.props
    const { currentNote, isNoteSet, titleInput = '', commentInput = '', opinions } = this.state

    if (!isNoteSet) {
      return
    }
    if (titleInput.trim().length === 0) {
      this.setState({ titleInput: '' })
      return
    }
    if (commentInput.trim().length === 0) {
      this.setState({ commentInput: '' })
      return
    }

    this.setState({ sendingOpinion: true })
    axios
      .post('/api/opinions/', {
        opinionable,
        opinionableId,
        note: currentNote,
        title: titleInput,
        comment: commentInput,
      })
      .then(() => {
        let lastOpinion
        if (opinions.length > 0) {
          lastOpinion = opinions[opinions.length - 1]
        }
        return axios
          .get(`/api/opinions/${opinionable}/${opinionableId}`, {
            params: {
              after: lastOpinion ? new Date(lastOpinion.createdAt).getTime() : undefined,
              limit: 10,
            },
          })
          .then(res => {
            const { opinions: newOpinions, currentUserOpinion } = res.data || {}
            this.setState({
              currentUserOpinion,
              totalOpinionsCount: Number.parseInt(res.headers['x-total-count'], 10),
            })
            this.updateOpinions(newOpinions)
          })
      })
      .then(() => {
        this.setState({
          sendingOpinion: false,
          titleInput: '',
          commentInput: '',
          currentNote: 0,
          isNoteSet: false,
        })
      })
      .catch(err => {
        captureException(err)
        this.setState({ sendingOpinion: false })
      })
  }

  render() {
    const { translate, locale, isLoggedIn, mostRecentOnTop, maxNote, subtitle, opinionableId } = this.props
    const {
      totalOpinionsCount,
      opinions,
      loadingMore,
      sendingOpinion,
      titleInput = '',
      commentInput = '',
      currentNote,
      isNoteSet,
      editingCurrentOpinion,
      currentUserOpinion,
    } = this.state

    const canLoadMore = totalOpinionsCount > opinions.length

    const moreButton = (
      <button
        type="button"
        onClick={this.onLoadMore}
        className="button is-white is-small has-margin-bottom-xxsmall has-text-blueTitle"
        disabled={loadingMore}
      >
        {translate('comments.loadMore')}
      </button>
    )

    const inputOpinionElement = (
      <div className="media">
        <form onSubmit={this.postOpinion} style={{ width: '100%' }}>
          <div className="media-content">
            <h3 className="has-text-weight-bold has-text-primary-blue has-padding-top-medium">
              {translate('opinions.createIncentive.gear')}
            </h3>
            {subtitle && <small>{subtitle}</small>}
            <div className="field">
              <div className="control" onMouseLeave={e => this.setNote(e, 0)}>
                {Array.from(Array(maxNote))
                  .map(Number.call, Number)
                  .map((el, index) => (
                    <button
                      type="button"
                      key={`starScore-${el}-forForm`}
                      className="button is-white"
                      onMouseEnter={e => this.setNote(e, index + 1)}
                      onClick={e => this.setNoteClick(e, index + 1)}
                    >
                      <span className={classNames({ 'has-text-primary': isNoteSet || index < currentNote }, 'icon')}>
                        <i
                          className={classNames({ fas: index < currentNote, far: !(index < currentNote) }, 'fa-star')}
                        />
                      </span>
                    </button>
                  ))}
              </div>
            </div>
            <div className="field">
              <label className="label is-small">{translate('opinions.create.title.title')}</label>
              <div className="control">
                <input
                  className="input is-small"
                  type="text"
                  placeholder={translate('opinions.create.title.placeholder')}
                  value={titleInput}
                  onChange={elt => this.setState({ titleInput: elt.target.value })}
                />
              </div>
            </div>

            <div className="field">
              <label className="label is-small" htmlFor="input-comment">
                {translate('opinions.create.comment.title')}
              </label>
              <div className="control">
                <textarea
                  id="input-comment"
                  className="textarea is-small"
                  placeholder={translate('opinions.create.comment.placeholder')}
                  value={commentInput}
                  onChange={elt => this.setState({ commentInput: elt.target.value })}
                />
              </div>
            </div>
            <div className="field">
              <div className="control">
                <button
                  type="submit"
                  className="button is-call-to-action is-small"
                  disabled={
                    !isLoggedIn ||
                    sendingOpinion ||
                    !isNoteSet ||
                    titleInput.trim().length === 0 ||
                    commentInput.trim().length === 0
                  }
                >
                  {translate('opinions.create.send')}
                </button>
              </div>
            </div>
          </div>
          {!isLoggedIn && <small>{translate('opinions.shouldBeConnected')}</small>}
        </form>
      </div>
    )

    return (
      <div className="comments-list">
        {canLoadMore && !mostRecentOnTop && moreButton}

        {totalOpinionsCount === 0 && (
          <EmptyData
            emptyableId={opinionableId}
            title={translate('opinions.empty.gear.title')}
            subtitle={translate('opinions.empty.gear.subtitle')}
            isSmall
          />
        )}

        {opinions.map((elt, idx) => {
          let avatarUrl
          if (elt.user.profilePicture) {
            avatarUrl = elt.user.profilePicture.url
          }
          if (!avatarUrl) {
            avatarUrl = EmptyImagesGenerator.getUserPlaceholder({ userId: elt.user.id })
          }
          const userFullName = `${elt.user.firstName.trim()} ${elt.user.lastName.trim()}`
          return (
            <div key={elt.id} className="media" itemProp="review" itemScope itemType="http://schema.org/Review">
              <div className="media-left">
                <figure className={classNames('image is-48x48 is-square')}>
                  <img
                    src={avatarUrl}
                    className={classNames('has-object-fit-cover is-rounded has-border-white')}
                    alt={userFullName}
                  />
                </figure>
              </div>
              <div className="media-content">
                <div className="content is-size-7">
                  <a href={`/users/${elt.createdBy}`} target="_blank" rel="noopener noreferrer">
                    <strong itemProp="author">{userFullName}</strong>
                  </a>
                  &nbsp;
                  <small
                    className={classNames('tooltip', { 'tooltip-bottom': idx === 0 }, { 'tooltip-top': idx > 0 })}
                    data-tooltip={new Date(elt.createdAt).toLocaleString()}
                  >
                    <time dateTime={new Date(elt.createdAt).toISOString()} itemProp="datePublished">
                      {moment(new Date(elt.createdAt))
                        .locale(locale)
                        .fromNow()}
                    </time>
                  </small>
                  <br />
                  <div>
                    <StarsDisplay
                      note={Number(elt.note)}
                      maxNote={Number(maxNote)}
                      isSmall
                      locale={locale}
                      isReviewRating
                    />
                    &nbsp;
                    <b className="has-text-primary-blue" itemProp="name">
                      {elt.title}
                    </b>
                    <div className="content" itemProp="description">
                      {elt.comment}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
        {canLoadMore && mostRecentOnTop && moreButton}
        {(!currentUserOpinion || editingCurrentOpinion) && inputOpinionElement}
      </div>
    )
  }
}

OpinionsList.propTypes = {
  translate: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool,
  opinionable: PropTypes.string.isRequired,
  opinionableId: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  opinions: PropTypes.array,
  averageNote: PropTypes.number.isRequired,
  currentUserOpinion: PropTypes.object,
  totalOpinionsCount: PropTypes.number,
  mostRecentOnTop: PropTypes.bool,
  maxNote: PropTypes.number,
}

OpinionsList.defaultProps = {
  isLoggedIn: false,
  opinions: [],
  subtitle: null,
  totalOpinionsCount: 0,
  mostRecentOnTop: false,
  currentUserOpinion: null,
  maxNote: 5,
}

module.exports = withTranslator(OpinionsList)
